export class TipoQuimicos {
  nombre: string;
  codigo: string;
  descripcion: string;
  imagen: string;
}
